import { render, staticRenderFns } from "./StepProgramParticipantsDocuments.vue?vue&type=template&id=71b64a47"
import script from "./StepProgramParticipantsDocuments.vue?vue&type=script&lang=js"
export * from "./StepProgramParticipantsDocuments.vue?vue&type=script&lang=js"
import style0 from "./StepProgramParticipantsDocuments.vue?vue&type=style&index=0&id=71b64a47&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports